import React from 'react';
import '../styles/MathLoading.css';

const MathLoading = () => {
    return (
        <div className="math-loading-container">
            <div className="math-loading-content">
                {/* Math Symbols Animation */}
                <div className="math-symbols">
                    <div className="symbol symbol-1">π</div>
                    <div className="symbol symbol-2">∑</div>
                    <div className="symbol symbol-3">∫</div>
                    <div className="symbol symbol-4">∞</div>
                    <div className="symbol symbol-5">√</div>
                    <div className="symbol symbol-6">±</div>
                    <div className="symbol symbol-7">×</div>
                    <div className="symbol symbol-8">÷</div>
                </div>
                
                {/* Loading Text */}
                <div className="loading-text">
                    <h3>جاري التحميل...</h3>
                    <p>مستر فادي نبيل</p>
                </div>
                
                {/* Progress Bar */}
                <div className="progress-container">
                    <div className="progress-bar">
                        <div className="progress-fill"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MathLoading; 